/* import obtenerConcesiones from "../concesiones/obtener";
import obtenerDirecciones from "../direccion/obtener"; */
import { toast } from "react-toastify";

import agruparArray from "../../historial/agruparArray";
import obtenerHistorialSinConcesion from "../historial/obtenerSinConcesion";
/* import expediente from "../../xml/obtenerExpedientePorAutorizacion"; */

export default async function obtenerSinConcesion(idContribuyente, data, setData) {
    let dataHistorial;

    const id = toast.loading("Cargando...");
    try {
        dataHistorial = await obtenerHistorialSinConcesion(idContribuyente);

        setData({ ...data, historial: [...dataHistorial], historialArray: [...agruparArray(dataHistorial, 10)], concesionActual: {} });
        toast.update(id, { render: "Hecho!", type: "success", isLoading: false, autoClose: 500, draggable: true });

    }
    catch (_) {
        toast.update(id, {
            render: "Ocurrió un problema con este contribuyente",
            type: "warning", isLoading: false, autoClose: 500, draggable: true
        });
    }
}